module.exports = __webpack_public_path__ + "img/backhand_index_pointing_down.6fd2997a.gif";